<template>
  <div>
    <div v-show="showChangeSchool&&!noFunctionRouterListName.includes($route.name)" class="breadcrumb-page">
      <div class="style-box">
        <span class="line"></span>
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem
            v-for="(item, index) in breadcrumbArr"
            :key="index"
            :to="item.url"
          >{{ item.name }}</BreadcrumbItem>
        </Breadcrumb>
        <div v-show="showChangeSchool" class="flex flexrow flexac">
          <div v-if="showChangeBtn" class="mockbot"></div>
          <div v-if="showChangeBtn">
            <SelectSchool
              :sty-type="2"
              :show-switch-btn="showSwitchBtn"
              @changeSchool="handleChangeSchool"
            ></SelectSchool>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import SelectSchool from '@c/searchBlock/SelectSchool.vue';
export default {
  name: 'BreadcrumbPage',
  components: {
    SelectSchool
  },
  data() {
    return {
      title: '',
      showChangeSchool: false,
      breadcrumbArr: [],
      routeInfo: '',
      showSwitchBtn: true
      // portOrg: -1, // 处于哪个端
    };
  },
  computed: {
    ...mapGetters(['currentRouteInfo']),
    ...mapState(['portOrg', 'noFunctionRouterListName']),
    filterShowChangeSchool() {
      return this.routeInfo.meta.filterShowChangeSchool ? this.routeInfo.meta.filterShowChangeSchool : [0, 1, 3];// 默认0、1、3 portOrg的显示
    },
    // 真正展示切换学校按钮的控制
    showChangeBtn() {
      return this.filterShowChangeSchool.includes(+this.portOrg);
    }
  },
  watch: {
    currentRouteInfo(newVal, oldVal) {
      this.routeInfo = newVal;
      console.log(this.routeInfo, '现在的路由是啥---432432');
      // 是否显示切换学校按钮
      if (this.routeInfo.meta.showChangeSchool == true) {
        this.showChangeSchool = true;
        this.showSwitchBtn = this.routeInfo.meta.showSwitchBtn !== undefined ? this.routeInfo.meta.showSwitchBtn : true;
      } else {
        this.showChangeSchool = false;
      }
      this.setBreadcrumb();
    }
  },
  created() {
    this.routeInfo = this.currentRouteInfo;
    this.setBreadcrumb();
  },
  mounted() {
    // 判断当前路由是否显示切换按钮
    if (this.$route.meta.showChangeSchool == true) {
      this.showChangeSchool = true;
      this.showSwitchBtn = this.routeInfo.meta.showSwitchBtn !== undefined ? this.routeInfo.meta.showSwitchBtn : true;
    } else {
      this.showChangeSchool = false;
    }
  },

  methods: {
    handleChangeSchool() {

    },
    handleBack() {
      this.$router.go(-1);
    },
    setBreadcrumb() {
      this.title = this.routeInfo.meta.title;
      this.breadcrumbArr = [];
      const metaBreadcrumbArr = (this.routeInfo.meta.breadcrumb && this.routeInfo.meta.breadcrumb.split('-')) || [];
      metaBreadcrumbArr.forEach(item => {
        this.breadcrumbArr.push({ url: '', name: item });
      });
      switch (this.breadcrumbArr.length) {
        case 2:
          break;
        case 3:
          this.breadcrumbArr[2].url = this.routeInfo.meta.activePath;
          break;
        case 4:
          this.breadcrumbArr[2].url = this.routeInfo.meta.activePath;
          this.breadcrumbArr[3].url = this.routeInfo.path;
          break;
        case 5:
          this.breadcrumbArr[2].url = this.routeInfo.meta.activePath;
          this.routeInfo.meta.activeTwoPath ? this.breadcrumbArr[3].url = this.routeInfo.meta.activeTwoPath : '';
          this.breadcrumbArr[4].url = this.routeInfo.path;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb-page {
  width: 100%;

  background-color: #fff;
  box-sizing: border-box;
  padding: 10px 16px 10px 16px;
  border-bottom: 1px solid #eff0f8;
  border-radius: 2px 2px 0 0;
  display: flex;
  align-items: center;
  .style-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    //flex-direction: column;
    .back {
      margin-right: 16px;
      width: 58px;
      height: 24px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #dcdfe6;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #606266;
      cursor: pointer;
    }
    .line {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #488ffa;
      margin-right: 4px;
    }
    .breadcrumb {
      // cursor: pointer;
    }
    .title-box {
      flex: 1;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 24px;
    }
  }
}
</style>
<style lang="scss">
.breadcrumb-page {
  .ivu-breadcrumb {
    color: #242e3a;
    .ivu-breadcrumb-item-separator {
      color: #242e3a;
    }
  }
  .ivu-breadcrumb > span:last-child {
    a {
      color: #488ffa !important;
    }
  }
}
.mockbot {
  width: 10px;
  height: 2px;
  background-color: #488ffa;
  margin: 0 5px;
}
</style>
